import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'cpcs-reconnect';
import I from 'immutable';
import cx from 'classnames';

import { lnk } from 'lib/routes';
import { freeRtvLeftSel, currentPlanSel, user_sel } from 'domain/env/EnvModel';
import SubscriptionType from 'pages/common/subscriptionType';
import { query_sel } from 'domain/router/RouterModel';

import injectSheet from 'lib/sheet';
import sheet from './sheet.js';

const P = injectSheet({
  P: {
    marginTop: 10,
  },
})(function({ classes, children }) {
  return <p className={classes.P} children={children} />;
});

function SubscriptionCongratulationPure({ classes }) {
  return (
    <div className={classes.PlanDetails}>
      <div className={cx(classes.topHeader, 'congratulation')}>Thank you for subscribing to ARTBnk!</div>
      <div className={classes.successFooter}>A copy of your invoice has been sent to the email address on file.</div>
      <div className={classes.successFooter}>
        If you have any questions about your plan please visit our
        <a href="https://support.artbnk.com/hc/en-us/requests/new" target="_blank" rel="noopener noreferrer" className={classes.help}>Help Center</a>
        to get in touch with support.
      </div>
    </div>
  );
}

SubscriptionCongratulationPure.propTypes = {
  classes: PropTypes.shape({
    PlanDetails: PropTypes.string,
    topHeader: PropTypes.string,
    successFooter: PropTypes.string,
    help: PropTypes.string,
  }).isRequired,
};

export const SubscriptionCongratulation = injectSheet(sheet)(SubscriptionCongratulationPure);

class PlanDetails extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    freeRtv: PropTypes.number,
    plan: PropTypes.instanceOf(I.Collection),
    query: PropTypes.shape({
      congratulation: PropTypes.string,
    }),
    user: PropTypes.instanceOf(I.Collection),
  }

  renderDetails = () => {
    const { classes, freeRtv, plan, user } = this.props;
    if (!plan || !plan.shortName || !user) return null;
    const renewalDate = user.renewalDate ? moment(user.renewalDate, 'YYYY-MM-DD').format('MMM DD, YYYY') : '';
    return (
      <div className={classes.PlanDetails}>
        <div className={classes.topHeader}>Subscription Details</div>
        <div className={classes.description}>
          <P>
            You have used <strong className={classes.strong}>{plan.freeRtvCountIncluded - freeRtv} of {plan.freeRtvCountIncluded}</strong> valuations included in your
            {' '}
            {
              plan.shortName !== 'SUBSCRIPTION_TYPE_MEMBER' ?
              'subscription' : 'free account'
            }.<br />
            {
              !!renewalDate && plan.shortName !== 'SUBSCRIPTION_TYPE_MEMBER' &&
                <span>This plan will automatically renew on {renewalDate}</span>
            }
          </P>
        </div>
        {
          plan.shortName === 'SUBSCRIPTION_TYPE_MEMBER' &&
            <div className={classes.successFooter}>
              To upgrade your plan, <Link to={lnk('upgradeSubscriptionLink')} className={classes.link}>click here</Link>.
            </div>
        }
        {
          plan.shortName !== 'SUBSCRIPTION_TYPE_MEMBER' &&
            <div className={classes.successFooter}>
              To upgrade or make changes to your plan, please
              <a href="https://support.artbnk.com/hc/en-us/requests/new" target="_blank" rel="noopener noreferrer" className={classes.help}>Contact Us</a>
            </div>
        }
        <SubscriptionType
          selected
          item={plan}
        />
        {
          plan.shortName !== 'SUBSCRIPTION_TYPE_MEMBER' &&
            <div className={classes.techFooter}>
              Annual subscriptions automatically renew and renewal may be canceled at any time.<br />
              *unused ARTBnk valuations do not roll over year to year
            </div>
        }
      </div>
    );
  }

  render() {
    const { query } = this.props;
    if (query.congratulation === 'thankForSubscribing') {
      return <SubscriptionCongratulation />;
    }
    return this.renderDetails();
  }
}

export default compose(
  connect({
    freeRtv: freeRtvLeftSel,
    plan: currentPlanSel,
    query: query_sel,
    user: user_sel,
  }),
  injectSheet(sheet),
)(PlanDetails);
